import React from "react";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";

function App() {
  return (
    <div className="container">
      <Header />
      <Form />
      <Footer />
    </div>
  );
}

export default App;
